/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationsModuleItemList_componentModule = {
    readonly location: {
        readonly title: string | null;
        readonly description: string | null;
        readonly imageUrl: string | null;
        readonly imageHeight: string | null;
        readonly imageWidth: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly linkData: {
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespLocationsModuleItemList_componentModule";
};
export type HpRespLocationsModuleItemList_componentModule$data = HpRespLocationsModuleItemList_componentModule;
export type HpRespLocationsModuleItemList_componentModule$key = {
    readonly " $data"?: HpRespLocationsModuleItemList_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModuleItemList_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespLocationsModuleItemList_componentModule",
  "type": "LocationsModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "location",
      "storageKey": null,
      "args": null,
      "concreteType": "Location",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageHeight",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageWidth",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "LocationItem",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cmsId",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "linkData",
              "storageKey": null,
              "args": null,
              "concreteType": "LinkData",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "SeoLink_linkData",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '14fb47a7412d87f0be200a863c551452';
export default node;
